export const _en = {
    addButton: {
        label: "Add state"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    modal: {
        add: {
            title: "Add state"
        }
    }

};


export const _fr = {
    addButton: {
        label: "État"
    },
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    dialog: {
        add: {
            title: "Ajout d'un état"
        }
    }
};